export default "__VITE_ASSET__$ZyTYt4N__"